import React from "react";
import { Chart } from "react-google-charts";
import "../GeographyChart/GeographyChart.css";

// Define the new data as an array of objects, replacing 'popularity' with 'exchange'
export const data = [
  { country: "Germany", exchange: 255, user: 620 },
  { country: "United States", exchange: 310, user: 300 },
  { country: "Brazil", exchange: 369, user: 400 },
  { country: "Canada", exchange: 430, user: 500 },
  { country: "France", exchange: 590, user: 600 },
  { country: "Russia", exchange: 720, user: 700 },
];
const GeographyChart = () => {
  // Transform the data from array of objects to the format needed by Google Charts
  const chartData = [
    ["Country", "Exchange", { role: "tooltip", type: "string" }],
  ];

  // Populate chartData with tooltip information, using 'exchange' instead of 'popularity'
  data.forEach((item) => {
    const tooltipContent = `Exchange: ${item.exchange}\nUsers: ${item.user}`;
    chartData.push([item.country, item.exchange, tooltipContent]);
  });

  // Handle the 'select' event
  const handleSelectEvent = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();

    if (selection.length === 0) return;

    const selectedRegion = chartData[selection[0].row + 1];
    console.log("Selected : " + selectedRegion[0]); // Access the country name (selectedRegion[0])
  };

  return (
    <>
      <section className="section">
        <div className="full-geo-container">
          <div className="full-geo-header">
            <h1>
              <span>Global Report :</span> Exchange and User Statistics by
              Country
            </h1>
          </div>

          <div className="full-geo-parent">
            <div className="full-geo-chart-container">
              <Chart
                chartType="GeoChart"
                data={chartData} // Use transformed data with 'Exchange'
                width="100%"
                height={420}
                chartEvents={[
                  {
                    eventName: "select",
                    callback: handleSelectEvent,
                  },
                ]}
                options={{
                  tooltip: { isHtml: false }, // Use text-based tooltips (default)
                  colors: ["#fdcc71"], // Set the color for regions to #FDCC71
                  backgroundColor: "#f8f8f7"
                }}
              />
            </div>
            <div className="full-geo-legend-table">
              <table>
                <thead>
                  <tr className="full-thead">
                    <td>Legend</td>
                    <td>Name</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#fdcc71" }}
                      ></i>
                    </td>
                    <td>Exchange :</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#fdcc71" }}
                      ></i>
                    </td>
                    <td>User :</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GeographyChart;
